import { useEffect, useState } from "react";
import { ArrowLeft, LogOut, Inbox } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function AdminPage() {
  const [token, setToken] = useState(() => sessionStorage.getItem("kariko_admin") || "");
  const [items, setItems] = useState(null);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const login = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    const form = new FormData(e.currentTarget);
    try {
      const res = await fetch(`${API}/api/admin/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: form.get("email"), password: form.get("password") }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(typeof data.detail === "string" ? data.detail : "Login failed");
      sessionStorage.setItem("kariko_admin", data.token);
      setToken(data.token);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const logout = () => {
    sessionStorage.removeItem("kariko_admin");
    setToken("");
    setItems(null);
  };

  useEffect(() => {
    if (!token) return;
    fetch(`${API}/api/admin/inquiries`, { headers: { Authorization: `Bearer ${token}` } })
      .then(async (r) => {
        if (!r.ok) throw new Error("expired");
        return r.json();
      })
      .then((d) => setItems(d.inquiries))
      .catch(() => logout());
  }, [token]);

  return (
    <div className="admin-shell" data-testid="admin-page">
      <header className="admin-top"><div className="content-width admin-top-inner">
        <img src="/logo-stacked-white.png" alt="KARIKO — Polyol Manufacturers" className="admin-logo" />
        {token && <button className="admin-logout" onClick={logout} data-testid="admin-logout-button"><LogOut size={13} /> Log out</button>}
      </div></header>
      {!token ? (
        <form className="admin-card" onSubmit={login} data-testid="admin-login-form">
          <h1>Admin sign in</h1>
          <p>View every inquiry submitted through the website.</p>
          {error && <p className="admin-error" data-testid="admin-error">{error}</p>}
          <label>EMAIL<input name="email" type="email" required autoComplete="username" data-testid="admin-email-input" /></label>
          <label>PASSWORD<input name="password" type="password" required autoComplete="current-password" data-testid="admin-password-input" /></label>
          <button className="button" type="submit" disabled={loading} data-testid="admin-login-button">{loading ? "Signing in…" : "Sign in"}</button>
        </form>
      ) : (
        <div className="admin-wrap">
          <div className="admin-head"><h1 data-testid="admin-inquiries-heading"><Inbox size={22} /> Inquiries</h1><a href="/" className="admin-back" data-testid="admin-back-link"><ArrowLeft size={14} /> Back to website</a></div>
          {items === null ? <div className="admin-empty">Loading…</div> : items.length === 0 ? <div className="admin-empty" data-testid="admin-empty">No inquiries yet.</div> : (
            <table className="admin-table" data-testid="admin-inquiries-table">
              <thead><tr><th>DATE</th><th>NAME</th><th>COMPANY</th><th>CONTACT</th><th>REQUIREMENT</th><th>APPLICATION</th><th>MESSAGE</th></tr></thead>
              <tbody>{items.map((it) => (
                <tr key={it.id} data-testid={`inquiry-row-${it.id}`}>
                  <td>{new Date(it.created_at).toLocaleString("en-IN", { dateStyle: "medium", timeStyle: "short" })}</td>
                  <td>{it.name}</td><td>{it.company || "—"}</td>
                  <td>{it.phone}<br />{it.email}</td>
                  <td>{it.requirement || "—"}</td><td>{it.application || "—"}</td><td>{it.message || "—"}</td>
                </tr>
              ))}</tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
}
